module.exports = __webpack_public_path__ + "static/media/md-eye-off.4227037a.svg";